import { HostAPIStudio } from './HostAPIStudio';
export class HostAPIEditor3 extends HostAPIStudio {
    constructor() {
        super(...arguments);
        this.components = {
            data: {
                getData: (editorPointer) => {
                    return this.platformApiMethods.document.components.data?.getData(editorPointer);
                },
                setData: (editorPointer, data) => {
                    return this.platformApiMethods.document.components.data?.setData(editorPointer, data);
                },
            },
            cssStyle: {
                get: (editorPointer) => {
                    return this.platformApiMethods.document.components.cssStyle?.get(editorPointer);
                },
                update: (editorPointer, cssStyle, shouldRemoveRelatedProperties) => {
                    return this.platformApiMethods.document.components.cssStyle?.update(editorPointer, cssStyle, shouldRemoveRelatedProperties);
                },
                remove: (editorPointer, paths) => {
                    return this.platformApiMethods.document.components.cssStyle?.remove(editorPointer, paths);
                },
            },
        };
    }
}
//# sourceMappingURL=HostAPIEditor3.js.map